'use strict';

var react = require('react');

const FALLBACK = {
  getCodeBaseFeature: () => false
};
const CodeBaseFeatureFlagsContext = react.createContext(FALLBACK);

module.exports = CodeBaseFeatureFlagsContext;
//# sourceMappingURL=CodeBaseFeatureFlagsContext.cjs.map
